import { ApisauceInstance } from 'apisauce';

const getRewardOverrideOptions = ({
  api,
  bonusDatasetRecordId,
}: {
  api: ApisauceInstance;
  bonusDatasetRecordId: string;
}) => {
  return api.get<BonusTypes.RewardOverrideOptions[]>(
    `/v1/driver_bonus/reward_override_options?bonus_dataset_record_id=${bonusDatasetRecordId}`,
  );
};

export default getRewardOverrideOptions;
